/**
 * Kildesystemet til en sak. Utledes i Saks API fra suffikset på EksternSakId.
 * Dalux-saker håndteres i Dalux, så Kundeportal lenker bare videre til dem.
 */
export const SakKilde = {
    SuperOffice: 'SuperOffice',
    Dalux: 'Dalux',
} as const;

export type SakKildeType = (typeof SakKilde)[keyof typeof SakKilde];

export interface INySakConfig {
    readonly kilde: SakKildeType;
    readonly url?: string;
}

export interface NySakConfigRequest {
    kundeNummer?: string;
    byggNummer?: string;
}
